import { createEntitySchemas } from '../../../utils/normalize'

export const ACTIVITY = 'organizationActivity'
export const activitySchemas = createEntitySchemas(ACTIVITY)
